import { render, staticRenderFns } from "./BaseWarning.vue?vue&type=template&id=7aca8d3c&scoped=true&"
import script from "./BaseWarning.vue?vue&type=script&lang=js&"
export * from "./BaseWarning.vue?vue&type=script&lang=js&"
import style0 from "./BaseWarning.vue?vue&type=style&index=0&id=7aca8d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca8d3c",
  null
  
)

export default component.exports